import { useCompleteFragment } from '@eluve/apollo-client';
import { Icon, LinkButton } from '@eluve/components';
import { externalChartsFragment } from '@eluve/frontend-appointment-hooks';
import { graphql } from '@eluve/graphql.tada';
import { useTranslation } from '@eluve/i18n';

interface ExternalChartLinkProps {
  appointmentId: string;
}

const SignedAppointmentDetailsFragment = graphql(
  `
    fragment SignedAppointmentDetails on Appointments {
      __typename
      id
      ...externalCharts
    }
  `,
  [externalChartsFragment],
);

export const ExternalChartLink: React.FC<ExternalChartLinkProps> = ({
  appointmentId,
}) => {
  const { t } = useTranslation();
  const appointment = useCompleteFragment({
    fragment: SignedAppointmentDetailsFragment,
    key: {
      id: appointmentId,
    },
  });

  const externalChartUrl = appointment?.external_charts?.[0]?.chartUrl;
  if (!externalChartUrl) {
    return null;
  }

  return (
    <LinkButton
      className="-ml-1"
      size="sm"
      href={externalChartUrl}
      variant="link"
    >
      {t('appointmentTools.page.viewExternalChart')}
      <Icon name="ExternalLink" size="auto" />
    </LinkButton>
  );
};
